// Src: https://redux.js.org/introduction/why-rtk-is-redux-today
// import { configureStore } from "@reduxjs/toolkit";
// import AuthReducer from "../reducers/AuthReducer";

// export const store = configureStore({
//   reducer: {
//     authUser: AuthReducer,
//   },
// });

import { createStore, combineReducers, applyMiddleware } from 'redux';
import persistReducer from "redux-persist/es/persistReducer";
import persistStore from "redux-persist/es/persistStore";
import { Persistor } from "redux-persist/es/types";
import storage from 'redux-persist/lib/storage';
import thunk from 'redux-thunk';

import AuthReducer from "../reducers/AuthReducer";
import ConfigReducer from "../reducers/ConfigReducer";
import RefreshTokenReducer from "../reducers/RefreshTokenReducer";

const rootReducer = combineReducers({
  auth: AuthReducer,
  config: ConfigReducer,
  refreshToken: RefreshTokenReducer
});

const persistConfig = {
  key: 'root',
  storage,
  whitelist: ['auth']
};

const persistedReducer = persistReducer(persistConfig, rootReducer);

export const store = createStore(persistedReducer, applyMiddleware(thunk));
export const persistor: Persistor = persistStore(store);
